import { useOutletContext } from 'react-router';

import { useTypedParams } from '@sorare/routing';

import type { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';

import type { Filters } from '#src/components/topPlayers/TopPlayers/TopPlayersFilters/types.ts';
import { TopPlayers } from '#src/components/topPlayers/TopPlayers/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const TopPlayersPage = () => {
  const { fixture, eventType } = useTypedParams<PageParams>();
  const { filters } = useOutletContext<{
    fixture: string;
    filters: Filters;
  }>();

  return (
    <TopPlayers
      eventType={eventType?.toUpperCase() as So5FixtureEvent}
      fixture={fixture}
      filters={filters}
    />
  );
};

export default TopPlayersPage;
